// SheepNewWeighInModal — thin sheep wrapper over RuminantNewWeighInModal.
import {
  RuminantNewWeighInModal,
  type LockedTeamMemberSource,
  type NewRuminantWeighInSession,
  type RuminantGroupOption,
} from '../cattle/ruminantPresentation.js';

export type NewSheepWeighInSession = NewRuminantWeighInSession;

type SheepNewWeighInModalProps = {
  onClose: () => void;
  onCreate: (session: NewSheepWeighInSession) => Promise<void>;
  authState?: LockedTeamMemberSource | null;
};

const FLOCK_OPTS: readonly RuminantGroupOption[] = [
  {v: 'rams', l: 'Rams'},
  {v: 'ewes', l: 'Ewes'},
  {v: 'feeders', l: 'Feeders'},
];

const SheepNewWeighInModal = ({onClose, onCreate, authState}: SheepNewWeighInModalProps) => (
  <RuminantNewWeighInModal
    title="New Sheep Weigh-In"
    groupLabel="Flock"
    groupPlaceholder="Select flock…"
    missingGroupError="Pick a flock."
    options={FLOCK_OPTS}
    onClose={onClose}
    onCreate={onCreate}
    authState={authState}
  />
);

export default SheepNewWeighInModal;
